import axios from 'axios'

class Account {
    constructor() {
        this.result = []
    }

    LoginApi = (data, setErr) => {
        const res = async () => {
            const resp = await axios
                .post('https://ips-backend.nextventures.com.pk/v1/credentials/login', {
                    email: data.email,
                    password: data.password,
                })
                .catch(function (error) {
                    setErr(error.response.data.message)
                    // message.error(error.response.data.message)
                    console.log(error)
                })
            return resp
        }
        return res()
    }
}
export default new Account()
